
import moment from 'moment-timezone';

import LeadFormPreviewPopup from './lead-form-preview-popup.vue';
import LeadFormEditorIframe from './lead-form-editor-iframe.vue';
import PopupWithClose from '@/components/popup/popup-with-close.vue';
import NoData from '@/components/common/no-data.vue';
import { CHART_FORMAT_DAILY_SHORT, CHART_FORMAT_BREAKDOWN } from '@/utils/dateUtil';
import {
  InstantFormStatus,
  InstantFormItem,
  defaultInstantFormItem,
  LeadAdsMobileEditorType,
  leadAdsMobileEditorLink,
  LeadgenEditorBusinessType,
} from '@/const/leadAds';
import { getInstantFormList as getInstantFormListApi } from '@/service';
import * as tool from 'src/utils/tool';
import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  ref,
  toRefs,
  watch,
} from 'vue-demi';
import accountState from '@/store/modules/account';
import adsCreativeState from '@/store/modules/ads_creative';
const name = 'LeadFormListPopup';
export default defineComponent({
  name,
  components: {
    LeadFormPreviewPopup,
    LeadFormEditorIframe,
    PopupWithClose,
    NoData,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, cxt) {
    const { proxy: _this } = getCurrentInstance() as ComponentInternalInstance;

    const { value } = toRefs(props);
    const curFormId = ref('');
    const curPageNum = ref(1);
    const previewFormItem = ref(defaultInstantFormItem as InstantFormItem);
    const formList = ref([] as InstantFormItem[]);
    const editorUrl = ref('');
    const editorType = ref(LeadAdsMobileEditorType.create);
    const initLoading = ref(true);
    const isPullUpLoading = ref(false);
    const canShowEmpty = ref(false);
    const showEmptyText = computed(() => canShowEmpty.value && formList.value.length === 0);
    const loadingText = computed(() => _this.$t('common_loading'));
    const adverId = computed(() => accountState.getters.adverId(accountState.state));
    const handleClose = () => {
      cxt.emit('input', false);
    };
    const resetFormList = () => {
      formList.value = [];
      curPageNum.value = 1;
      initLoading.value = true;
    };
    const formatTime = (time: string) =>
      `${moment(time).format(CHART_FORMAT_DAILY_SHORT)}&nbsp;&nbsp;${moment(time).format(CHART_FORMAT_BREAKDOWN)}`;
    const openInstantFormEditor = ({ page_id, type }: { page_id?: string; type: LeadAdsMobileEditorType }) => {
      const editorQueryObject: any = {
        type,
        preview_mode: 'embedded', // mobile lite 编辑器标示
        lang: _this.$i18n.locale,
        business_type: LeadgenEditorBusinessType.instant_page,
        adv_id: adverId.value,
      };
      if (page_id) {
        editorQueryObject.page_id = page_id;
      }
      editorUrl.value = leadAdsMobileEditorLink + tool.jsonToQuery(editorQueryObject);
      editorType.value = type;
      // 添加一下打开 leadgen 编辑器的页面识别参数
      const newQueryStr = tool.jsonToQuery({
        ..._this.$route.query,
        page_type: 'leadgen_editor',
      });
      history.replaceState('', '', `${location.pathname}${newQueryStr}`);
    };
    const handleCreate = () => {
      openInstantFormEditor({
        type: LeadAdsMobileEditorType.create,
      });
    };
    const getInstantFormList = (needRedirect = true) => {
      isPullUpLoading.value = true;
      getInstantFormListApi({
        page: curPageNum.value,
      }).then(({ data }) => {
        initLoading.value = false;
        isPullUpLoading.value = false;
        if (!data) {
          return;
        }
        const { page_list, pagination } = data;
        if (pagination.total_count === 0) {
          if (needRedirect) {
            handleCreate();
          } else {
            canShowEmpty.value = true;
          }
        }
        if (page_list.length) {
          if (!curFormId.value) {
            curFormId.value = page_list.find(item => item?.preview_url)?.id;
          }
          formList.value = [...formList.value, ...page_list];
          curPageNum.value++;
        }
      });
    };
    const checkIsDraft = (status: InstantFormStatus) => status === InstantFormStatus.DRAFT;
    const onEditorIframeFinish = () => {
      editorUrl.value = '';
      canShowEmpty.value = true;
      resetFormList();
      getInstantFormList(false);

      // 移除一下打开 leadgen 编辑器的页面识别参数
      const newQuery = {
        ..._this.$route.query,
      };
      delete newQuery.page_type;
      const newQueryStr = tool.jsonToQuery(newQuery);
      history.replaceState('', '', `${location.pathname}${newQueryStr}`);
    };
    const handlePreview = (form: InstantFormItem) => {
      previewFormItem.value = form;
      _this.$trackEvent('adp_waplite_click', {
        fastcr_creative_upload: 'leads_form_preview',
      });
    };
    const handleEdit = (form: InstantFormItem) => {
      openInstantFormEditor({
        page_id: form.id,
        type: LeadAdsMobileEditorType.edit,
      });
      _this.$trackEvent('adp_waplite_click', {
        fastcr_creative_upload: 'leads_form_edit',
      });
    };
    const onSelectForm = (form: InstantFormItem) => {
      if (checkIsDraft(form.status)) {
        return;
      }
      adsCreativeState.mutations.setInstantForm(form);
      cxt.emit('select-form');
      curFormId.value = form.id;
      handleClose();
    };

    watch(value, val => {
      if (val) {
        resetFormList();
        getInstantFormList();
      }
    });
    return {
      formList,
      curFormId,
      handleEdit,
      editorType,
      formatTime,
      editorUrl,
      initLoading,
      handleClose,
      onSelectForm,
      loadingText,
      checkIsDraft,
      handleCreate,
      showEmptyText,
      handlePreview,
      previewFormItem,
      isPullUpLoading,
      getInstantFormList,
      onEditorIframeFinish,
    };
  },
});
